window.dataLayer = window.dataLayer || [];
if (window.gtag !== 'undefined') {
	window.gtag = function() {
		window.dataLayer.push(arguments);
	};
	window.gtag('consent', 'default', { 'ad_storage': 'denied', 'analytics_storage': 'denied' });
}
window.klaroConfig = {
	mustConsent: false,
	hideLearnMore: false,
	hideDeclineAll: true,
	acceptAll: true,
	styling: {
		theme: ['light']
	},
	translations: {
		en: {
			consentNotice: {
				title: 'Cookie Consent',
				description: "We use cookies to improve our website and services and for marketing purposes. You can control what cookies we set under 'Cookie Settings'. You can change your cookie settings at any time.",
				learnMore: 'Cookie Settings'
			},
			consentModal: {
				title: 'Cookie Consent',
				description: "Customize the services that we'd like to use on this website."
			},
			purposes: {
				analytics: {
					title: 'Analytics',
					description: 'These services allow us to identify issues with or problems with the website and to improve our service.',
				},
				targeting: {
					title: 'Targeting',
					description: 'Targeting cookies allow us to provide a personalized experience and help our marketing.',
				},
				required: {
					title: 'Required Cookies',
					description: 'These cookies are necessary for the operation of the website'
				}
			}
		}
	},
	services: [
		{
			name: 'required',
			purposes: ['required'],
			required: true
		},
		{
			name: 'analytics',
			purposes: ['analytics'],
			onAccept: `
                gtag('consent', 'update', {'analytics_storage': 'granted'});
                dataLayer.push({'event': 'klaro-analytics-accepted'});
            `,
			onDecline: `
              gtag('consent', 'update', {'analytics_storage': 'denied'});
              dataLayer.push({'event': 'klaro-analytics-denied'});
            `,
		},
		{
			name: 'performance',
			purposes: ['performance'],
			onAccept: `
                gtag('consent', 'update', {'ad_storage': 'granted'});
                dataLayer.push({'event': 'klaro-performance-accepted'});
            `,
			onDecline: `
              gtag('consent', 'update', {'ad_storage': 'denied'});
              dataLayer.push({'event': 'klaro-performance-denied'});
            `,
		},
		{
			name: 'targeting',
			purposes: ['targeting'],
			onAccept: `
                gtag('consent', 'update', {'personalization_storage': 'granted'});
                dataLayer.push({'event': 'klaro-personalisation-accepted'});
            `,
			onDecline: `
              gtag('consent', 'update', {'personalization_storage': 'denied'});
              dataLayer.push({'event': 'klaro-personalisation-denied'});
            `
		}
	]
};
